import { SplitPartModel } from '../models/split-part.model';

export interface ICommSchemeSetup {
  id: number;
  code: string;
  name: string;
  isActive: boolean;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  tiers: SplitPartModel[];
  parties: SplitPartModel[];
  isDefault: boolean;
}
